import script from "./IssueShowComment.vue?vue&type=script&lang=ts&setup=true"
export * from "./IssueShowComment.vue?vue&type=script&lang=ts&setup=true"

import "./IssueShowComment.vue?vue&type=style&index=0&id=0a5d682e&lang=scss&scoped=true"

import exportComponent from "/var/build/production/construction-site-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a5d682e"]])

export default __exports__